import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import WorkshopLanding from "@/components/WorkshopLanding";
import WorkshopThankYou from "@/components/WorkshopThankYou";
import SemaforoPage from "@/components/semaforo/SemaforoPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Lo Studio è disponibile OVUNQUE (preview Emergent, localhost, deploy interno),
// TRANNE sul dominio pubblico marketing di Massimiliano: lì l'app mostra SOLO la landing
// (lo Studio non viene montato → invisibile e non raggiungibile).
// NB: elenco esplicito dei domini pubblici → il preview funziona sempre, qualunque sia l'URL.
const host = window.location.hostname.replace(/^www\./, "");
const PUBLIC_MARKETING_DOMAINS = ["massimilianopulla.com"];
const IS_PUBLIC_SITE = PUBLIC_MARKETING_DOMAINS.includes(host);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/workshop/grazie" element={<WorkshopThankYou />} />
          <Route path="/workshop" element={<WorkshopLanding />} />
          <Route path="/semaforo" element={<SemaforoPage />} />
          {IS_PUBLIC_SITE ? (
            <>
              <Route path="/" element={<WorkshopLanding />} />
              <Route path="/*" element={<Navigate to="/workshop" replace />} />
            </>
          ) : (
            <Route path="/*" element={<App />} />
          )}
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
